
import {PageTrade as Trade} from './Trade'
import styles from "./index.module.scss";
import { RootHeader } from "@/components/RootHeader";
import { ContentTabs } from "./components/ContentTabs";

export const PageTrade = ()  =>{
  

  return <div className={styles.pageTrade} >

    <RootHeader title={'挂单市场'} />
    <ContentTabs active={'trade'} />
    <Trade />
    <div className={styles.whitespace}></div>
  </div>
}
